// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__Udb4z","main":"Layout_main__mIuK3","content":"Layout_content__ffqXr"};